<div class="jit-nps-close-button">
  <jit-icon-simple iconId="x-outline" size="32"></jit-icon-simple>
</div>